import {useEffect, useState} from "react";
import ActionBar from "~/layout/ActionBar";
import {Col, Row, Skeleton} from "antd";
import _ from "lodash"
import {
    apiError,
    handleRequest
} from "~/utils";

import {
    reportApi
} from "~/api";
import ContractReportTable from "../../components/contract/ContractTable";
import ContractReportSearch from "../../components/contract/ContractSearch";

function ContractReport() {

    //Group items
    const [items, setItems] = useState([]);

    const [loading, setLoading] = useState(false);

    const [filter, setFilter] = useState({});

    //Load data
    useEffect(() => { handleLoad(); }, [filter]);

    const handleLoad = async () => {
        setLoading(true);
        let [error, response] = await handleRequest(reportApi.contract(filter));
        let message = apiError(`Lấy thông tin báo cáo thất bại`, error, response);
        if (!message) {
            setItems(response.data)
        }
        setLoading(false);
    }

    const handleFilterChange = (key, value) => {
        const newFilter = {
            ...filter,
            [key]: value,
            page: 1
        };
        setFilter(newFilter);
    };

    return (
        <>
            <ActionBar title={'Hợp đồng'}></ActionBar>

            <div className={'container'}>
                <div className="content pd-1 pdb-3 form" style={{overflow:'auto'}}>
                    <ContractReportSearch filter={filter} onChange={handleFilterChange} />
                    <Row gutter={10}>
                        <Col className="gutter-row" md={24} span={24} lg={24}>
                            {loading && <Skeleton />}
                            {(!loading && !_.isEmpty(items)) && <div className={'group-wrapper'}>
                                <h3 className={'pdt-2 pdb-2 pdr-2 text-lg color-red'}>Số lượng</h3>
                                <ContractReportTable items={items.service} type={'count'} types={items.types} total={items.total} />
                                <h3 className={'pdt-2 pdb-2 pdr-2 text-lg color-red'}>Giá trị</h3>
                                <ContractReportTable items={items.service} type={'amount'} types={items.types} total={items.total} />
                            </div>
                            }
                        </Col>
                    </Row>
                </div>
            </div>
        </>
    )
}

export default ContractReport;